import { Link } from 'react-router-dom';
import type { Manhwa } from '@/mocks/manhwas';

interface ManhwaCardProps {
  manhwa: Manhwa;
  size?: 'normal' | 'large';
}

export default function ManhwaCard({ manhwa, size = 'normal' }: ManhwaCardProps) {
  const isLarge = size === 'large';

  return (
    <Link
      to={`/manhwa/${manhwa.id}`}
      className={`group block bg-background-50 border border-background-200/70 rounded-lg overflow-hidden transition-all duration-300 hover:border-primary-200 cursor-pointer ${
        isLarge ? '' : ''
      }`}
    >
      <div className={`relative overflow-hidden ${isLarge ? 'aspect-[3/4]' : 'aspect-[3/4]'}`}>
        <img
          src={manhwa.coverImage}
          alt={manhwa.title}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          title={`${manhwa.title} - 好看韩国漫画免费在线观看`}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
          <span className="text-xs text-white bg-primary-500/90 px-2 py-1 rounded-full whitespace-nowrap">
            立即阅读
          </span>
        </div>
        <div className="absolute top-2 left-2">
          <span className={`text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap ${
            manhwa.status === '连载中'
              ? 'bg-primary-500 text-background-50'
              : 'bg-secondary-500 text-background-50'
          }`}>
            {manhwa.status}
          </span>
        </div>
        <div className="absolute top-2 right-2">
          <span className="text-xs bg-background-950/70 text-background-50 px-2 py-0.5 rounded-full flex items-center gap-1 whitespace-nowrap">
            <i className="ri-star-fill text-accent-500 text-[10px]"></i>
            {manhwa.rating}
          </span>
        </div>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="text-sm md:text-base font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors duration-200">
          {manhwa.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1 line-clamp-2 leading-relaxed">
          {manhwa.description}
        </p>
        <div className="flex items-center justify-between mt-3 pt-3 border-t border-background-100">
          <span className="text-xs text-foreground-500 flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {manhwa.views > 10000 ? `${(manhwa.views / 10000).toFixed(0)}万` : manhwa.views}
          </span>
          <span className="text-xs text-primary-500 font-medium whitespace-nowrap">
            {manhwa.totalChapters}话
          </span>
        </div>
      </div>
    </Link>
  );
}